import { Svg } from 'common/assets'
import { useResolution } from 'common/hooks'
import { FlexWrapperBrand, LogoImg } from 'modules/Footer/styled'
import { StyledCopyRight } from './styled'

export const BrandEntities = () => {
 
  return (
    <>
      <FlexWrapperBrand>
        <LogoImg src={Svg.Logo} />
        <StyledCopyRight />
      </FlexWrapperBrand>
    </>
  )
}
